// extracted by mini-css-extract-plugin
module.exports = {"row":"row__2KYjI","row_2":"row_2__1WnES","notes":"notes__2FoKM","cont":"cont__2qzGM","cell":"cell__xFRPX","container":"container__2wPrt","activities":"activities__3exEa"};